import React from 'react';
import { CrudPage } from '@restavo/crud';
import { useStorefrontNewsPage } from 'src/features/storefrontNews';

const StorefrontNews = React.memo(() => {
  const { page } = useStorefrontNewsPage();
  return <CrudPage {...page} />;
});
StorefrontNews.displayName = 'StorefrontNews';

export default StorefrontNews;
